import React from 'react';

import Button from './../styled/Button';
import Icon from './../styled/Icon';

const Dialogue = ({
  editor,
  onChange,
  closeMenu,
  type = 'bulleted-list',
  iconType = 'ul',
  altType = 'numbered-list',
  itemType = 'list-item',
  defaultBlock = 'paragraph',
}) => {
  if (!editor) return null;

  const { value } = editor;

  const { document } = value;
  const parent = document.getParent(value.blocks.first().key);
  const isActive = parent && parent.type === type;

  const isListItem = value.blocks.some(node => node.type === itemType);

  return (
    <Button
      active={isActive}
      onMouseDown={(e) => {
        e.preventDefault();
        const change = value.change();
        if (isActive && isListItem) {
          change
            .setBlocks(defaultBlock)
            .unwrapBlock(type);
        } else if (isListItem) {
          change
            .unwrapBlock(altType)
            .wrapBlock(type);
        } else {
          change
            .setBlocks(itemType)
            .wrapBlock(type);
        }

        onChange(change);
      }}
    >
      <Icon
        className={`fas fa-list-${iconType}`}
      />
    </Button>
  );
};

export default Dialogue;

export const BulletedList = (props) =>
  <Dialogue
    type='bulleted-list'
    iconType='ul'
    altType='numbered-list'
    {...props}
  />;

export const NumberedList = (props) =>
  <Dialogue
    type='numbered-list'
    iconType='ol'
    altType='bulleted-list'
    {...props}
  />;
